<script setup lang="ts">
  const { error } = defineProps<{
    error: Error;
  }>();

  function handleClearError() {
    clearError({ redirect: "/" });
  }

  if (import.meta.client && !navigator.onLine) {
    navigateTo("/offline");
  }
</script>

<template>
  <div
    class="flex h-screen w-full flex-col items-center justify-center space-y-4"
  >
    {{ error }}
    <h1 class="text-palma text-3xl font-bold">
      {{ error.message }}
    </h1>
    <UButton class="max-w-fit" @click="handleClearError">
      Go Back Home
    </UButton>
  </div>
</template>

<style scoped></style>
